/** Person-name fields — default to first search row when `row` is not set. */
const PERSON_NAME_KEYS = new Set(['name', 'fathersName', 'surname', 'firstName']);

/**
 * Groups search options into rows.
 * - Explicit `option.row` (0, 1, …) always wins.
 * - Otherwise: name/fathersName/surname/firstName → row 0, rest → row 1.
 * - If only one logical group, returns a single row.
 */
export function groupSearchOptionsIntoRows(searchOptions = []) {
    if (!searchOptions.length) {
        return [];
    }

    const hasExplicitRow = searchOptions.some((option) => option.row != null && option.row !== undefined);

    if (hasExplicitRow) {
        const rowMap = new Map();
        searchOptions.forEach((option) => {
            const rowIndex = Number(option.row) || 0;
            if (!rowMap.has(rowIndex)) {
                rowMap.set(rowIndex, []);
            }
            rowMap.get(rowIndex).push(option);
        });
        return [...rowMap.entries()]
            .sort(([a], [b]) => a - b)
            .map(([, options]) => options);
    }

    const firstRow = [];
    const secondRow = [];

    searchOptions.forEach((option) => {
        if (PERSON_NAME_KEYS.has(option.key)) {
            firstRow.push(option);
        } else {
            secondRow.push(option);
        }
    });

    if (firstRow.length > 0 && secondRow.length > 0) {
        return [firstRow, secondRow];
    }

    if (searchOptions.length > 4) {
        const splitAt = Math.ceil(searchOptions.length / 2);
        return [searchOptions.slice(0, splitAt), searchOptions.slice(splitAt)];
    }

    return [searchOptions];
}
